<app-modal-icon [type]="'alert'"></app-modal-icon>

<div class="confirmation-content">
  <h3 class="title" [innerHTML]="titleKey | translate: titleParams"></h3>

  <p class="description" [innerHTML]="descriptionKey | translate: descriptionParams"></p>
</div>

<div class="buttons-group-wrapper">
  <app-modal-buttons-group>
    <button pso-outline-button (click)="backClicked.emit()">
      {{ 'no' | translate | uppercase }}
    </button>

    <button pso-button [color]="'primary-b-blue'" (click)="confirmClicked.emit()">
      {{ 'yes' | translate | uppercase }}
    </button>
  </app-modal-buttons-group>
</div>
